import { CoursePageLayout } from "../courseBlocks";
import { mathMenuData } from "../../../data/SubjectMenu/mathMenuData";
import { mathsImg } from "../../../data/SubjectContent/maths/img";
import { mathsConcernBlocks } from "../../../data/SubjectContent/maths/concern";

export function PageMathsConcern() {
    return (
        <CoursePageLayout
            title="數學科 | 年度重點項目"
            subtitle="CURRENT MAIN CONCERN"
            menuData={mathMenuData}
            nowIndex={2}
            topImage={{ src: mathsImg.concernTop }}
            blocks={mathsConcernBlocks}
        />
    );
}
